import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/seekpass',
    authDomain: 'login.seek.com',
    clientDomain: 'www.seekpass.co',
    clientId: 'MSfGHbexUFqlJPDTWXFNLhg6sV1WMVoS',
    environment: 'prod',
    redirectPath: '/auth-redirect',
    realm: 'Username-Password-Authentication',
    brand: Brand.SEEKPASS,
    contactUs: {
        en: 'https://help.seekpass.co/hc/en-us/requests/new',
    },
    product: Product.SEEKPASS,
};
//# sourceMappingURL=seekpass_co.js.map